// ===============================
// pages/ProductDetails.jsx
// ===============================

import React, {
  useContext,
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import axios from "axios";

import {
  CartContext,
} from "../../context/CartContext";

import "./ProductDetails.css";

const ProductDetails = () => {

  // ===============================
  // ROUTER
  // ===============================

  const { id } = useParams();

  const navigate = useNavigate();

  // ===============================
  // CONTEXT
  // ===============================

  const {
    addToCart,
  } = useContext(CartContext);

  // ===============================
  // STATES
  // ===============================

  const [product, setProduct] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const [quantity, setQuantity] =
    useState(1);

  // ===============================
  // FETCH PRODUCT
  // ===============================

  useEffect(() => {

    fetchProduct();

  }, [id]);

  const fetchProduct = async () => {

    try {

      const res = await axios.get(
        `http://localhost:5000/api/products/${id}`
      );

      setProduct(res.data);

      setLoading(false);

    } catch (error) {

      console.log(error);

      setLoading(false);

    }

  };

  // ===============================
  // QUANTITY
  // ===============================

  const increaseQty = () => {

    setQuantity(
      quantity + 1
    );

  };

  const decreaseQty = () => {

    if (quantity > 1) {

      setQuantity(
        quantity - 1
      );

    }

  };

  // ===============================
  // ADD TO CART
  // ===============================

  const handleAddToCart = () => {

    addToCart({
      ...product,
      quantity,
    });

  };

  // ===============================
  // BUY NOW
  // ===============================

  const handleBuyNow = () => {

    addToCart({
      ...product,
      quantity,
    });

    navigate("/cart");

  };

  // ===============================
  // LOADING
  // ===============================

  if (loading) {

    return (

      <div className="product-loading">

        <h1>
          Loading Product...
        </h1>

      </div>

    );

  }

  // ===============================
  // NOT FOUND
  // ===============================

  if (!product) {

    return (

      <div className="product-loading">

        <h1>
          Product Not Found
        </h1>

      </div>

    );

  }

  return (
    <div className="product-details-page">

      <div className="container product-wrapper">

        {/* ===============================
            LEFT SIDE
        =============================== */}

        <div className="product-left">

          <div className="main-image">

            <img
              src={product.image}
              alt={product.name}
            />

          </div>

        </div>

        {/* ===============================
            RIGHT SIDE
        =============================== */}

        <div className="product-right">

          {/* CATEGORY */}

          <span className="product-category">

            {product.category}

          </span>

          {/* TITLE */}

          <h1>
            {product.name}
          </h1>

          {/* BRAND */}

          <div className="product-meta">

            <span>
              Brand:
            </span>

            <strong>
              {
                product.brand ||
                "No Brand"
              }
            </strong>

          </div>

          {/* WARRANTY */}

          <div className="product-meta">

            <span>
              Warranty:
            </span>

            <strong>
              {
                product.warranty ||
                "No Warranty"
              }
            </strong>

          </div>

          {/* PRICE */}

          <p className="product-price">

            ₹{product.price}

          </p>

          {/* DESCRIPTION */}

          <p className="product-description">

            {product.description}

          </p>

          {/* FEATURES */}

          <div className="product-features">

            <h3>
              Product Highlights
            </h3>

            <ul>

              <li>
                Premium Quality Product
              </li>

              <li>
                Fast Delivery Available
              </li>

              <li>
                Easy Returns & Refund
              </li>

              <li>
                Secure Online Payment
              </li>

            </ul>

          </div>

          {/* STOCK */}

          <div className="stock-box">

            <span>
              Availability:
            </span>

            <strong
              className={
                product.stock > 0
                  ? "in-stock"
                  : "out-stock"
              }
            >

              {product.stock > 0
                ? `In Stock (${product.stock})`
                : "Out Of Stock"}

            </strong>

          </div>

          {/* QUANTITY */}

          <div className="quantity-wrapper">

            <h4>
              Quantity
            </h4>

            <div className="quantity-box">

              <button
                onClick={decreaseQty}
              >
                -
              </button>

              <span>
                {quantity}
              </span>

              <button
                onClick={increaseQty}
              >
                +
              </button>

            </div>

          </div>

          {/* TOTAL */}

          <div className="product-total">

            Total:

            <strong>
              ₹
              {product.price *
                quantity}
            </strong>

          </div>

          {/* BUTTONS */}

          <div className="product-buttons">

            <button
              className="cart-btn"
              onClick={
                handleAddToCart
              }
            >
              Add To Cart
            </button>

            <button
              className="buy-btn"
              onClick={
                handleBuyNow
              }
            >
              Buy Now
            </button>

          </div>

        </div>

      </div>

    </div>
  );
};

export default ProductDetails;